import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Checkbox as MUICheckbox } from "@material-ui/core";
import { Colors } from "../../styles";
import { CheckboxProps } from "@material-ui/core/Checkbox";
import clsx from "clsx";

const useStyles = makeStyles({
    root: {
        width: 28,
        height: 28,
        marginLeft: 10,
        backgroundColor: Colors.white,
        "& span": {
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
        },
        "&:hover": {
            backgroundColor: "transparent",
        },
        "&:before": {
            width: 28,
            height: 28,
            display: "block",
            content: '""',
        },
    },
    icon: {
        width: 28,
        height: 28,
        display: "block",

        borderWidth: 1,
        borderStyle: "solid",
        borderColor: Colors.anthracite25,

        borderRadius: 5,
        "input:disabled ~ &": {
            background: Colors.white,
        },
        "&:before": {
            width: 28,
            height: 28,
            display: "block",
            content: '""',
        },
    },
    checkedIcon: {
        backgroundColor: Colors.mellowYellow,
        display: "block",
        borderWidth: 1,
        borderStyle: "solid",

        "input:disabled ~ &": {
            width: 28,
            height: 28,
            borderColor: Colors.anthracite25,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M22.568 6.058a.81.81 0 0 0-.697.045 1.47 1.47 0 0 0-.511.45l-8.182 14.39-4.648-7.645a.826.826 0 0 0-.558-.45.938.938 0 0 0-.697.09c-.217.12-.372.3-.465.54a.84.84 0 0 0 .046.719l5.578 9.263c.186.36.465.54.837.54h.093c.186 0 .341-.06.465-.18s.217-.27.279-.45l9.111-16.098a.985.985 0 0 0-.093-.72.99.99 0 0 0-.558-.494z' fill='%23cecdcc'/%3E%3C/svg%3E\")",
        },
        "input:not(disabled) ~ &": {
            width: 28,
            height: 28,
            borderColor: Colors.mellowYellow,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M22.568 6.058a.81.81 0 0 0-.697.045 1.47 1.47 0 0 0-.511.45l-8.182 14.39-4.648-7.645a.826.826 0 0 0-.558-.45.938.938 0 0 0-.697.09c-.217.12-.372.3-.465.54a.84.84 0 0 0 .046.719l5.578 9.263c.186.36.465.54.837.54h.093c.186 0 .341-.06.465-.18s.217-.27.279-.45l9.111-16.098a.985.985 0 0 0-.093-.72.99.99 0 0 0-.558-.494z' fill='%23fff'/%3E%3C/svg%3E\")",
        },
        "&:before": {
            width: 28,
            height: 28,
            display: "block",
            content: '""',
        },
    },
    label: {},
});

type Props = CheckboxProps;

export const Checkbox: FC<Props> = ({ ...other }: Props) => {
    const classes = useStyles();
    return (
        <MUICheckbox
            {...other}
            className={classes.root}
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
        />
    );
};
